import { inject } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary, ViewLarge, ViewMedium, Viewport, ViewSmall } from 'bernie-view';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { DisplayAd } from 'constants/ads';
import { ExtendedContextStore } from 'types/flex-definitions';
import { InfositePageName, SearchPageName } from 'constants/pages';
import { PackageType } from 'models/multi-item/multi-item-types';

import { MesoDisplayAd } from './meso-display-ad';
import { SwxlFooter } from 'components/common/footer/swxl-footer';

interface MesoFooterProps {
  pageName: string;
  isDateless: boolean;
  context?: ExtendedContextStore;
}

@withLocalization
@inject('context')
export class MesoFooter extends React.Component<MesoFooterProps & LocalizedComponentProps> {
  public render() {
    const { pageName, isDateless, context } = this.props;

    return Object.values(SearchPageName).some(val => val === pageName) ? (
      <HSRFooter context={context} pageName={pageName} />
    ) : (
      <HISFooter isDateless={isDateless} context={context} pageName={pageName} />
    );
  }
}

interface FooterProps {
  isDateless?: boolean;
  context?: ExtendedContextStore;
  pageName?: string;
}

const HSRFooter: React.FunctionComponent<FooterProps> = () => (
  <ErrorBoundary label="meso.footer">
    <div className="uitk-grid all-grid-align-center all-t-padding-six">
      <section className="uitk-grid all-grid-align-center">
        <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
        <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
        <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
      </section>
    </div>
  </ErrorBoundary>
);

const isPackagePath = (pageName: string): boolean =>
  Object.values(PackageType).some((packageName: string) => InfositePageName[packageName] === pageName);

const HISFooter: React.FunctionComponent<FooterProps> = ({ isDateless, context, pageName }) => (
  <ErrorBoundary label="meso.footer">
    <div className="uitk-grid all-grid-align-center all-y-padding-four all-cell-1-1">
      <div className="uitk-cell all-cell-1-1 all-b-padding-four">
        <section className="uitk-grid all-grid-align-center">
          <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
          {isPackagePath(pageName) ? <MesoDisplayAd {...DisplayAd.FOOTER_CM4} /> : <MesoDisplayAd {...DisplayAd.FOOTER_CM6} />}
        </section>
      </div>
      {isDateless && <HISSwxlFooter context={context} />}
    </div>
  </ErrorBoundary>
);

const HISSwxlFooter: React.FunctionComponent<FooterProps> = ({ context }) => (
  <Viewport>
    <ViewSmall>
      <div className="uitk-cell uitk-flex uitk-flex-grow-1 uitk-grid all-grid-align-center all-y-padding-four all-x-padding-four">
        <SwxlFooter context={context} className="uitk-cell all-cell-1-1 all-b-padding-four swxl" />
      </div>
    </ViewSmall>
    <ViewMedium>
      <div className="uitk-cell uitk-flex uitk-flex-grow-1 uitk-grid all-grid-align-center all-y-padding-four">
        <SwxlFooter context={context} className="uitk-cell all-cell-1-1 all-b-padding-four swxl" />
      </div>
    </ViewMedium>
    <ViewLarge>
      <div className="uitk-cell uitk-flex uitk-flex-grow-1 uitk-grid all-grid-align-center all-y-padding-four">
        <SwxlFooter context={context} className="uitk-cell all-cell-1-1 all-b-padding-four swxl" />
      </div>
    </ViewLarge>
  </Viewport>
);
